import { DateUtils } from 'mw-style-react';
import { DATE_FORMAT } from 'constants';

export default {
  // Получить даты по заданому промежутку
  getRangeDate(range) {
    const curDate = new Date().getTime();
    const timeZone = new Date().getTimezoneOffset();
    const timeZoneOffest = timeZone * 60 * 1000;
    const min = 60 * 1000;
    const hour = min * 60;
    const day = hour * 24;
    const from = new Date();
    let newDate;

    switch (range) {
      case 'all':
        from.setHours(0, 0, 0, 0);
        from.setFullYear(2018, 8, 1);

        newDate = {
          from: from.getTime(),
          to: DateUtils.endOf(curDate, 'day'),
        };
        break;
      case 'today':
        from.setHours(0, 0, 0, 0);

        newDate = {
          from: from.getTime(),
          to: DateUtils.endOf(curDate, 'day'),
        };
        break;
      case 'yesterday':
        newDate = {
          from: DateUtils.startOf(curDate - day, 'day'),
          to: DateUtils.endOf(curDate - day, 'day'),
        };
        break;
      case 'lastWeek':
        newDate = {
          from: curDate - day * 7,
          to: DateUtils.endOf(curDate, 'day'),
        };
        break;
      case 'lastMonth':
        newDate = {
          from: curDate - day * 30,
          to: DateUtils.endOf(curDate, 'day'),
        };
        break;
      case 'previousMonth':
        const dS = new Date();
        const dE = new Date();
        dS.setMonth(dS.getMonth() - 1);
        dS.setDate(1);
        dS.setHours(0, 0, 0);
        dE.setDate(0);
        dE.setHours(23, 59, 59);
        newDate = {
          from: DateUtils.dateToUnixtime(dS),
          to: DateUtils.dateToUnixtime(dE),
        };
        break;

      default:
        return false;
    }

    return {
      from: Math.round((newDate.from - timeZoneOffest) / 1000),
      to: Math.round((newDate.to - timeZoneOffest) / 1000),
    };
  },

  // Duedate по умолчанию
  getDefaultDuedate() {
    return DateUtils.todayEnd() + 5 * 24 * 60 * 60;
  },

  // Формат даты
  getDateRage(startDate, endDate) {
    if (startDate !== endDate) {
      return `${DateUtils.toDate(startDate, DATE_FORMAT)} - ${DateUtils.toDate(
        endDate,
        DATE_FORMAT
      )}`;
    }
    return DateUtils.toDate(endDate, DATE_FORMAT);
  },

  // Определение градации цвета по мере приближения срока выполенения
  getDueDateTemperature(event) {
    if (!event.inProgress) return 'blue';
    const now = DateUtils.unixtime();
    const diff = event.endDate - now;
    let color = 'blue';
    if (diff > 0 && diff <= 2 * 24 * 60 * 60) {
      color = 'yellow';
    } else if (diff < 0) {
      color = 'red';
    }
    return color;
  },

  relativeDate(unixtime, [t1, t2, t3, t4, t5, t6, t7]) {
    const now = new Date().getTime() / 1000;
    const delta = Math.round(now - unixtime);
    const minute = 60;
    const hour = minute * 60;
    const day = hour * 24;

    if (delta < 30) {
      return t1;
    }
    if (delta < minute) {
      return `${delta} ${t2}`;
    }
    if (delta < 2 * minute) {
      return t3;
    }
    if (delta < hour) {
      return `${Math.floor(delta / minute)} ${t4}`;
    }
    if (Math.floor(delta / hour) === 1) {
      return t5;
    }
    if (delta < day) {
      return `${Math.floor(delta / hour)} ${t6}`;
    }
    if (delta < day * 2) {
      return t7;
    }
    return DateUtils.toDate(unixtime, DATE_FORMAT);
  },

  getTimeAgo(unix) {
    const todayDate = DateUtils.unixtime();
    const unixDiff = todayDate - unix;
    const minute = 60;
    const hour = 60 * 60;
    const day = 60 * 60 * 24;
    let timeAgo;
    if (unixDiff < 10) {
      return 'now';
    }
    if (unixDiff < minute) {
      timeAgo = `${unixDiff}s`;
    } else if (unixDiff > day) {
      return null;
    } else if (unixDiff < hour) {
      const minutesAgo = Math.floor(unixDiff / minute);
      timeAgo = `${minutesAgo}m`;
    } else {
      const hoursAgo = Math.floor(unixDiff / hour);
      timeAgo = `${hoursAgo}h`;
    }
    return timeAgo;
  },
};
